import React from 'react'
import { Tag } from 'antd'
import { TOP_UP_PACKAGES } from "../../constants/topupPackages"
   
const TopupPackageTag = ({packageKey}) => {
  const pkg = TOP_UP_PACKAGES[packageKey]

  return <Tag color={pkg?.color || ''}>{pkg?.name || packageKey}</Tag>
}
  
export default TopupPackageTag